import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { getApiClient, initializeApiClient } from "../../../../Services/apiService";


export const GetAllPR_AgeGroup = createAsyncThunk(
  "dropdowns/PR_AgeGroup",
  async (_, { rejectWithValue }) => {
    try {
      await initializeApiClient();
      const apiClient = await getApiClient();
      const response = await apiClient.post("api/DropDowns/GetAllPR_AgeGroup");

      // Extract data from the response object
      const data = response.data.result; // Assuming response has a "data" field
      console.log(data, "agegrop");

      return data; // Return the extracted data
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);

const PR_AgeGroupDropDown = createSlice({
  name: "PR_AgeGroupDropDown",
  initialState: {
    PR_AgeGroupDropDown: [],
    loadingPR_AgeGroupDropDown: false,
    errorPR_AgeGroupDropDown: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(GetAllPR_AgeGroup.pending, (state, action) => {
        state.loadingPR_AgeGroupDropDown = true;
        state.PR_AgeGroupDropDown = action.payload;
        state.errorPR_AgeGroupDropDown = null;
      })
      .addCase(GetAllPR_AgeGroup.fulfilled, (state, action) => {
        state.loadingPR_AgeGroupDropDown = false;
        state.PR_AgeGroupDropDown = action.payload; // Assuming payload has the desired data
      })
      .addCase(GetAllPR_AgeGroup.rejected, (state, action) => {
        state.loadingPR_AgeGroupDropDown = false;
        state.errorPR_AgeGroupDropDown = action.payload;
      });
  },
});

export default PR_AgeGroupDropDown.reducer;
